var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"account-message"},[_vm._v("Welcome "+_vm._s(_vm.username)+"!")]),_vm._m(0),_c('router-link',{staticClass:"btn",attrs:{"to":"/my-account/manage-plan/top-up"}},[_vm._v("View Packages")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"message"},[_vm._v("You have successfully created your account "),_c('br')])
}]

export { render, staticRenderFns }